export default __webpack_public_path__ + "static/media/994.cd40de5a.png";